const validateEmail = (email) => {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase())
}

const getEmailName = (email) => {
  // Get the name part of email if any
  if (email.match(/^.+(?=@)/)) {
    return email.match(/^.+(?=@)/)[0] // get the name part of the email
  }
  return email
}

const maskEmail = (email) => {
  if (typeof email !== 'string' || !email) return ''
  const atIndex = email.lastIndexOf('@')
  if (atIndex < 0) return '**'
  return `${email.slice(0, Math.min(2, atIndex))}**${email.slice(atIndex)}`
}

export default {
  validateEmail,
  getEmailName,
  maskEmail,
}
